module.exports = __webpack_public_path__ + "static/media/RobotoMono-Light.b82d827b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Fonts/RobotoMono-Light.ttf
// module id = 111
// module chunks = 0